var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Loading',{attrs:{"data":[_vm.bcd]}},[_c('h2',[_vm._v("Policies")]),_c('FWMLv2PolicyViz',{attrs:{"policies":_vm.policies}}),_c('h2',[_vm._v("NATVS-Policies")]),_c('FWMLv2PolicyViz',{attrs:{"policies":_vm.natvs_policies}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }